import safeCreateAction from "../../../actions/safeCreateAction";
/**
 * change the user interface language
 */
export const setLanguage = safeCreateAction("SET_USER_LANGUAGE", (lang) => lang);
/**
 * enable or disable advanced mode
 */
export const setAdvancedMode = safeCreateAction("SET_ADVANCED_MODE", (advanced) => ({ advanced }));
export const setProfilesVisible = safeCreateAction("SET_PROFILES_VISIBLE", (visible) => ({ visible }));
export const setDesktopNotifications = safeCreateAction("SET_DESKTOP_NOTIFICATIONS", (enabled) => enabled);
export const setHideTopLevelCategory = safeCreateAction("SET_HIDE_TOPLEVEL_CATEGORY", (hide) => ({ hide }));
export const showUsageInstruction = safeCreateAction("SHOW_USAGE_INSTRUCTION", (usageId, show) => ({ usageId, show }));
export const setRelativeTimes = safeCreateAction("SET_RELATIVE_TIMES", (enabled) => enabled);
export const setForegroundDL = safeCreateAction("SET_FOREGROUND_DL", (enabled) => enabled);
